import { Badge } from '@chakra-ui/react'

type Props = {
  priority?: string | null
}

function normalizePriority(priority?: string | null): string {
  return (priority ?? '').trim().toLowerCase()
}

function colorScheme(priority: string): string {
  if (priority === 'low') return 'green'
  if (priority === 'medium') return 'blue'
  if (priority === 'high') return 'orange'
  if (priority === 'critical') return 'red'
  return 'gray'
}

function displayLabel(priority: string): string {
  if (!priority) return 'No priority'
  return priority.charAt(0).toUpperCase() + priority.slice(1)
}

export default function TaskPriorityBadge({ priority }: Props) {
  const normalized = normalizePriority(priority)

  return (
    <Badge
      colorScheme={colorScheme(normalized)}
      borderRadius="md"
      px={2.5}
      py={0.5}
      fontWeight="600"
      fontSize="xs"
      textTransform="none"
    >
      {displayLabel(normalized)}
    </Badge>
  )
}
